import type { Omit } from "@stenajs-webui/core";
import type { FC } from "react";

import {
  CommonDateInputField,
  type CommonDateInputFieldProps,
} from "../../../../../common-ui/form-fields/CommonDateInputField";
import { getFieldProps } from "../../../../../common-ui/form-fields/getFieldProps";
import type { TrackerCategory } from "../../../../../common/tracking/trackerService";
import { useUpdateField } from "../../../../../common/update-information/hooks/useUpdateField";
import type { DateInputFieldKeys } from "../../../../../services/update-form/updateFormReducer";

export interface DateInputFieldProps extends Omit<
  CommonDateInputFieldProps,
  "onValueChange" | "value" | "trackerAction"
> {
  name: DateInputFieldKeys;
  trackerCategory: TrackerCategory;
}

export const DateInputField: FC<DateInputFieldProps> = ({ name, ...props }) => {
  const fieldProps = useUpdateField<DateInputFieldKeys>(name);

  return (
    <CommonDateInputField
      {...props}
      {...getFieldProps(props, fieldProps)}
      changed={fieldProps.initialValue !== fieldProps.editedValue}
    />
  );
};
